import { render, staticRenderFns } from "./CommpanyBrandEdit.vue?vue&type=template&id=a98b7058&"
import script from "./CommpanyBrandEdit.vue?vue&type=script&lang=js&"
export * from "./CommpanyBrandEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports